import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {ResellerGroupsListFilter} from './ResellerGroupsListFilter'

const ResellerGroupsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddResellerGroupModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-resellergroup-table-toolbar='base'>
      <ResellerGroupsListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add resellergroup */}
      <button type='button' className='btn btn-primary' onClick={openAddResellerGroupModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='RESELLERGROUP.TABLE.CREATERESELLERGROUP' defaultMessage={"Add ResellerGroup"} />
      </button>
      {/* end::Add resellergroup */}
    </div>
  )
}

export {ResellerGroupsListToolbar}
